<app-block-slideshow [withDepartments]="true"></app-block-slideshow>

<!-- <section id="about" class="wow fadeInUp">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 about-img">
          <img src="../../../assets/images/about-image3.jpg" alt="Why Choose ITD">
        </div>
  
        <div class="col-lg-6 contentt section-header ">
          <h2 >Why Choose NVT <i  class="fa fa-question ms-1" aria-hidden="true" style="font-size: 30px; color: #FF6801 !important;"></i></h2>
          <ul style="list-style: none;">
             <li><i class="fa fa-check-square-o" style="padding-right: 4px; color:#FF6801"></i> Group Specialized in ICT for 8 Years</li>
             <li><i class="fa fa-check-square-o" style="padding-right: 4px; color:#FF6801"></i> Access Huge Inventory Available</li>
             <li><i class="fa fa-check-square-o" style="padding-right: 4px; color:#FF6801"></i> Members covers 30+ Countries</li>
             <li><i class="fa fa-check-square-o" style="padding-right: 4px; color:#FF6801"></i> Trusted by Worldwide Buyers</li>
             <li><i class="fa fa-check-square-o" style="padding-right: 4px; color:#FF6801"></i> Technical Support</li>
             <li><i class="fa fa-check-square-o" style="padding-right: 4px; color:#FF6801"></i> No Minimum Order Requirement</li>
             <li><i class="fa fa-check-square-o" style="padding-right: 4px; color:#FF6801"></i> Quality Products With Warranty</li>
          </ul>
 
        </div>
      </div>
  
    </div>
  </section> -->

<app-block-products-carousel
    header="Featured Products"
    [products]="latestProducts"
></app-block-products-carousel>


<!-- <app-block-banner></app-block-banner> -->


<div class="container">
	<hr>
	<p style="text-align: center;"><b>FEATURED BRANDS</b></p>
    <owl-carousel-o [options]="{loop:true,autoplay:true,margin:5,items:8,width:50}">
        <ng-template  carouselSlide *ngFor="let brand of brands">
            <a [routerLink]="['/brands/'+brand.slug]">
                <img style="object-fit: cover;" src="{{environment.baseurl+brand.image}}"> 
            </a>
        </ng-template>
    </owl-carousel-o>
</div>

<style>
  
.iconnn {
	padding: 0 17px 22px 0;
	float: left;
}

.iconnn img {
	width: auto;
	height: 120px;
}

#services .box h4 {
	font-family: inherit;
	color: #606060;
	padding: 0 0 6px 0;
	font-weight: 600;
	font-size: 20px;
	text-align: justify;
	margin-bottom: 0;
}

#services .box p {
	margin: 0;
	line-height: 20px;
	color: #212529;
	list-style: none;
	padding: 8px 20px 20px 180px;
	font-size: 14px;
	text-align: justify;
	letter-spacing: 1px;
}
/* 
.brands {
	width: 100%;
	padding-top: 20px;
}

.brands_slider_container {
	height: 130px;
	border: solid 1px #e8e8e8;
	box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
	padding-left: 97px;
	padding-right: 97px;
	background: #fff;
}

.brands_slider {
	height: 100%;
	margin-top: 35px;
}

.brands_item {
	height: 100%;
}

.brands_item img {
	max-width: 100%;
} */

.owl-carousel .owl-item img {
	display: block;
}

.brands_nav {
	position: absolute;
	top: 78%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	padding: 5px;
	cursor: pointer;
}

.brands_nav i {
	color: #e5e5e5;
	-webkit-transition: all 200ms ease;
	-moz-transition: all 200ms ease;
	-ms-transition: all 200ms ease;
	-o-transition: all 200ms ease;
	transition: all 200ms ease;
}

.brands_prev {
	left: 40px;
}

.brands_next {
	right: 40px;
}

.item {
	padding: 5px;
}

.form-control {
	border-color: #e0e0e0;
	border-radius: 0;
	box-shadow: none;
	height: 45px;
}

.contentt h2::before {
	content: "";
	margin-left: 50px;
	position: absolute;
	display: block;
	width: 50px;
	height: 3px;
	background: #FF6801;
	bottom: 0;
	left: 0;
}

.section-header {
	margin: 0 0 5px 0;
}

.section-header h2 {
	font-size: 28px;
	color: #FF6801;
	text-transform: uppercase;
	font-weight: 700;
	position: relative;
	font-family: "Raleway", sans-serif;
	padding-bottom: 20px;
}

.fpppara {
	color: inherit;
	padding: 10px 0 20px 0;
	line-height: 20px;
	font-size: 14px;
	letter-spacing: 1px;
}

.section-header h2::before {
	content: "";
	position: absolute;
	display: block;
	width: 50px;
	height: 3px;
	background: #FF6801;
	bottom: 0;
	left: 0;
	margin: 0;
}

#about {
	padding: 100px 0 0 70px;
}

#about .about-img {
	overflow: hidden;
    display: flex;
    justify-content: center;
}

#about .about-img img {
	/* margin-left: 15px; */
	max-width: 100%;
    
}

#about .contentt h2 {
	color: #FF6801;
	font-weight: 700;
	font-size: 28px;
	margin: 0;
	font-family: "Raleway", sans-serif;
	position: relative;
	text-transform: uppercase;
}

#about .contentt i {
	font-size: 20px;
	padding-right: 4px;
	color: #FF6801;
}

#about .contentt ul {
	list-style: none;
	padding: 20px 20px 20px 0;
}

#about .contentt ul li {
	list-style: none;
	padding: 4px 20px 8px 5px;
	font-size: 14px;
	letter-spacing: 1px;
	color: inherit;
	border-bottom: 1px solid #e7e7e7;
}

.cat_head {
	letter-spacing: 1px;
	font-weight: 600;
	border-color: #FF6801 !important;
	background: #FF6801 !important;
	font-size: 16px;
}

.dropdown-menu li {
	border: 1.2px solid #eaeaea;
	padding: 2px 0;
}

.imgid {
	padding: 0 13px;
	border: 1.2px solid #c7c7c7;
}

@media (max-width: 768px) {
	.iconnn {
		width: 100%;
		height: auto;
	}

	.iconnn img {
	    width: 50%;
        height: auto;
        display: block;
        margin-left: auto;
        margin-right: auto;
	}

	#services .box p {
		padding: 0;
	}

	#services .box h4 {
		text-align: center;
	}

	.section-header h2 {
		color: #FF6801;
		padding: 2px 0 11px 0;
		font-weight: 700;
		font-size: 27px;
	}

	#about {
		padding: 25px 0 0 0;
	}

	#about .contentt ul {
		padding: 0;
	}

	.cart_quote_beater {
		width: 150px;
	}
}
</style>